var _g, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnFileAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 241,
    viewBox: "0 0 201 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.82 50.1602C134.352 50.1549 129.11 47.981 125.242 44.1154C121.375 40.2499 119.198 35.0082 119.19 29.5402V0.910156H27.0603C23.5256 0.910156 20.0255 1.60649 16.76 2.95947C13.4945 4.31245 10.5275 6.29553 8.02857 8.79541C5.52961 11.2953 3.54757 14.263 2.1958 17.5291C0.844037 20.7951 0.149079 24.2954 0.150392 27.8301V190.05C0.150392 197.187 2.98538 204.032 8.03198 209.078C13.0786 214.125 19.9233 216.96 27.0603 216.96H137.66C144.797 216.96 151.642 214.125 156.688 209.078C161.735 204.032 164.57 197.187 164.57 190.05V50.1602H139.82Z",
    fill: "#FF9908"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.09 171.52H59.0503C50.1806 171.52 42.9902 178.71 42.9902 187.58V224.859C42.9902 233.729 50.1806 240.919 59.0503 240.919H184.09C192.96 240.919 200.15 233.729 200.15 224.859V187.58C200.15 178.71 192.96 171.52 184.09 171.52Z",
    fill: "#FF9908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.94 214.29V221.56H96.4102V214.29H103.94Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.321 216.08H115.051L113.181 221.56H105.521L116.521 191.71H124.901L135.901 221.56H128.151L126.321 216.08ZM124.45 210.55L120.71 199.49L116.921 210.55H124.45Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.051 191.49V221.56H138.771V191.49H146.051Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.21 115C76.1413 114.392 76.2633 113.778 76.5591 113.243C76.8549 112.707 77.31 112.277 77.8611 112.011C78.4122 111.746 79.0321 111.658 79.6353 111.761C80.2384 111.863 80.7947 112.15 81.2273 112.583C81.6599 113.016 81.9474 113.572 82.0498 114.175C82.1522 114.778 82.0646 115.398 81.7991 115.949C81.5335 116.501 81.1031 116.956 80.5676 117.251C80.0321 117.547 79.4179 117.669 78.8101 117.6L44.6602 151.75L95.6602 126.75C95.6602 126.75 101.38 105.4 107.89 98.9004L94.8901 85.9004C88.3901 92.4104 67.04 98.1404 67.04 98.1404L42.04 149.14L76.21 115Z",
    fill: "#FF9908"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.649 91.3212L102.476 71.1475L92.5832 81.0399L112.757 101.214L122.649 91.3212Z",
    fill: "#FF9908"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFileAi);
export default __webpack_public_path__ + "static/media/icn_file_ai.02cd7cacc646eb69e6d4265bd52eb90f.svg";
export { ForwardRef as ReactComponent };